import { create } from 'zustand';
import type { QuotaExceededInfo } from '@/lib/api';

/** v0.3.x (AIトークン利用上限管理): QuotaExceededModal の開閉状態。
 *  design-and-code M-2 対応: 既に開いている間は open() を no-op にし、連打による多重発火・
 *  表示内容の差し替えを防ぐ (最初に検知した違反を表示し続ける)。 */
type QuotaModalState = {
  isOpen: boolean;
  info: QuotaExceededInfo | null;
  open: (info: QuotaExceededInfo) => void;
  close: () => void;
};

export const useQuotaModalStore = create<QuotaModalState>((set, get) => ({
  isOpen: false,
  info: null,
  open: (info) => {
    if (get().isOpen) return;
    set({ isOpen: true, info });
  },
  close: () => set({ isOpen: false }),
}));
